import { EditLocaleRequest, EditPasswordRequest, EditProfileRequest } from "@shared/zod/schemas/requests/user"
import { DefaultResponse } from "@shared/zod/schemas/responses/common"

import { axiosAuth } from "./generic/AxiosInterceptor/AxiosInterceptor"

/**
 * Updates the authenticated user's password
 */
export const changePassword = async (req: EditPasswordRequest): Promise<DefaultResponse> => {
  const res = await axiosAuth({
    url: "/user/password",
    method: "patch",
    data: req,
  })

  return res.data
}

/**
 * Updates the authenticated user's profile
 */
export const editProfile = async (req: EditProfileRequest): Promise<DefaultResponse> => {
  const res = await axiosAuth({
    url: "/user/profile",
    method: "patch",
    data: req,
  })

  return res.data
}

/**
 * Updates the authenticated user's preferred locale
 */
export const editLocale = async (req: EditLocaleRequest): Promise<DefaultResponse> => {
  const res = await axiosAuth({
    url: "/user/locale",
    method: "patch",
    data: req,
  })

  return res.data
}
